// src/config.js
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8001",
  NATURAL_LANGUAGE_SEARCH_URL: process.env.REACT_APP_NL_SEARCH_URL || "http://192.168.0.101:3001",
  
  // Development mode - set to true to bypass Google Auth for testing
  DEV_MODE: process.env.REACT_APP_DEV_MODE === 'true',
  
  // External Candidate URL Configuration
  EXTERNAL_CANDIDATE_BASE_URL: process.env.REACT_APP_EXTERNAL_CANDIDATE_URL || "https://training.artemis.xpheno.work/candidate/",
  
  // Google OAuth Configuration
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "62901136810-cv8odj8vvaqldhj95b7cac6kndrmvu3v.apps.googleusercontent.com",
  ALLOWED_DOMAIN: "xpheno.com"
  
  // DEPRECATED: ALLOWED_EMAILS is now managed in the backend database
  // Authorization is handled by the backend API which checks the authorized_users table
};

export default config;